<script>
import { computed, h, ref, resolveComponent } from 'vue';

export default {
  props: {
    bgColor: {
      type: String,
      default: '#fff'
    },
    resize: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots, emit, attrs, expose }) {
    const panelResize = ref(false);
    const gnbWidth = ref(310);
    const resizeBeforeWidth = ref(0);
    const resizeBeforePositionX = ref(0);
    const resizeLineTop = ref(0);
    const resizeLineLeft = ref(0);
    const cScroll = resolveComponent('c-scroll');

    const headerResizeBoxStyle = computed(() => {
      let tmpStyle = {};
      tmpStyle['height'] = '100%';
      tmpStyle['width'] = '6px';
      return tmpStyle;
    });
    const resizeLineStyle = computed(() => {
      let tmpStyle = {};
      tmpStyle['position'] = 'absolute';
      tmpStyle['height'] = '140px';
      tmpStyle['left'] = resizeLineLeft.value;
      return tmpStyle;
    });

    function headerDragEnd(event) {
      if (panelResize.value) {
        let nWidth = Number(event.pageX - resizeBeforePositionX.value) + resizeBeforeWidth.value;
        gnbWidth.value = nWidth;
        panelResize.value = false;
      }
    }

    function headerDragOver(event) {
      if (panelResize.value && event.layerX > 10) {
        resizeLineLeft.value = event.layerX + 'px';
      }
    }

    function headerDragStart(event) {
      if (panelResize.value) return;
      panelResize.value = true;
      let $pEL = event.target.parentElement;
      resizeBeforeWidth.value = $pEL.getBoundingClientRect().width;
      resizeBeforePositionX.value = $pEL.getBoundingClientRect().left + resizeBeforeWidth.value;
      resizeLineLeft.value = event.layerX + 'px';
    }

    const footerView = h('div', { class: 'c-layout-footer' }, [slots.footer && slots.footer()]);
    const cContainer = h('div', { class: 'c-container' }, [
      h(cScroll, { style: { padding: '0 35px', display: 'flex', flexDirection: 'column' } }, () => [
        slots.contents(),
        slots.footer && footerView
      ])
    ]);
    const contentsView = h(
      'div',
      {
        class: 'c-layout-contents',
        style: { backgroundColor: ' #f1f2f7', flex: '1 1 auto' }
      },
      [cContainer]
    );

    const constentsContainer = h(
      'div',
      {
        class: 'c-layout-body',
        style: {
          backgroundColor: props.bgColor,
          width: slots.lnb && `calc(100% - ${gnbWidth.value}px`
        }
      },
      [slots.contents && contentsView]
    );
    return () =>
      h(
        'div',
        {
          class: { 'c-layout': true },
          onMousemove: headerDragOver,
          onDragover: headerDragOver,
          onMouseup: headerDragEnd,
          onDragend: headerDragEnd
        },
        [
          slots.lnb &&
            h(
              'div',
              {
                class: 'c-layout-lnb',
                style: { width: `${gnbWidth.value}px` }
              },
              [slots.lnb()]
            ),
          props.resize &&
            h(
              'div',
              {
                class: 'c-layout-resize',
                style: headerResizeBoxStyle.value,
                onDragstart: headerDragStart,
                onMousedown: headerDragStart
              },
              [
                h('div', { class: 'c-layout-resize--icon' }, [
                  h('lego-icon', {
                    iconType: 'df',
                    icon: 'oval_solid',
                    iconSize: '16',
                    primary: true
                  })
                ])
              ]
            ),
          props.resize &&
            panelResize.value &&
            h('div', { class: 'c-layout-resize-line', style: resizeLineStyle.value }),
          constentsContainer
        ]
      );
  }
};
</script>
<style lang="scss" scoped>
.c-layout {
  height: 100%;
  display: flex;
  position: relative;
  overflow: hidden;

  &-body {
    width: 100%;
  }

  &-resize {
    cursor: w-resize;
    border-right: 1px solid $color--primary;
    text-align: center;
    position: relative;

    &--icon {
      transform: rotate(270deg);
      position: absolute;
      width: 23px;
      height: 23px;
      background-color: $color--ui-11;
      border: 1px solid $color--primary;
      border-radius: 23px;
      left: -5px;
      top: calc(50% - 12px);
      pointer-events: none;

      i {
        vertical-align: middle;
      }
    }
  }

  &-resize-line {
    width: 6px;
    border-left: dashed 1px rgba($color--primary, 0.3);
    left: -100px;
  }
}
</style>
